import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { extend, extend_page, extend_count, backend } from "../../components/apipath";
import { dateHelper } from "../../modules/helpers";
import Swal from "sweetalert2";
import { ColGroup } from "../../components/ColGroup.js";

function ExtendRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState({
        name: '',
        status: '',
        start: '',
        end: ''
    });

    const SUBJECT_OPTIONS = ["FAR", "AUD", "REG", "BAR", "ISC", "TCP"];

    const parseSubjects = (value) =>
    String(value || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

    const joinSubjects = (arr) => (arr || []).join(",");

    /** 讀取展延申請記錄 */
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const params = {
                studentName: search.name || '',
                status: search.status || '',
                startDate: search.start || '',
                endDate: search.end || '',
                page: page - 1,
                rows
            };
            const response = await axios.get(`${extend_page(page - 1, rows)}`, {
                headers: { token },
                params
            });
            setRequestList(response.data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };
    
    const fetchPageData = async () => {
        try {
            const params = {
                studentName: search.name || '',
                status: search.status || '',
                startDate: search.start || '',
                endDate: search.end || ''
            };
            const response = await axios.get(`${extend_count}`, {
                headers: { token },
                params
            });
            setRowsCount(response.data?.[0]?.total || 0);
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };


    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);

    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    /** 進入編輯模式 */
    const startEditing = (req) => {
    setEditingRequest(req);
    setUpdatedData({
        ...req,
        subject: parseSubjects(req.subject), // 轉成陣列
    });
    };

    /** 處理輸入變更 */
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const toggleSubject = (subj) => {
    setUpdatedData((prev) => {
        const current = Array.isArray(prev.subject) ? prev.subject : parseSubjects(prev.subject);
        const next = current.includes(subj)
        ? current.filter((s) => s !== subj)
        : [...current, subj];
        return { ...prev, subject: next };
    });
    };

    /** 儲存變更 */
    const saveChanges = async () => {
        try {
        const dataToSend = {
        ...updatedData,
        subject: Array.isArray(updatedData.subject)
            ? updatedData.subject.join(",")
            : updatedData.subject,
        request_id: editingRequest.request_id,
        };
    
        await axios.put(`${extend}`, dataToSend, {
        headers: {
            token: token,
            Authorization: `Bearer ${token}`
        }
        });
    
        setRequestList((prevList) =>
        prevList.map((req) =>
            req.request_id === editingRequest.request_id ? dataToSend : req
        )
        );
    
        setEditingRequest(null);
        Swal.fire({
        icon: "success",
        title: "更新成功",
        confirmButtonText: "確認"
        });
    } catch (error) {
        console.error("Error updating requestList:", error);
        Swal.fire({
        icon: "error",
        title: "更新失敗",
        text: "請稍後再試",
        confirmButtonText: "確認"
        });
    }
    };
    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const colWeights = [1,1,1,1,1,1,4,1];

    return (
        <div className="mt100 container-fluid">
            <div className="mt-2">
                {loading ? (
                    <p>載入中...</p>
                ) : (
                    <>
                    <div className="row mb-3">
                        <div className="col-md-2 mb-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="學生姓名"
                                value={search.name}
                                onChange={(e) => setSearch({ ...search, name: e.target.value })}
                            />
                        </div>
                        <div className="col-md-2 mb-2">
                            <select
                                className="form-control"
                                value={search.status}
                                onChange={(e) => setSearch({ ...search, status: e.target.value })}
                            >
                                <option value="">全部狀態</option>
                                <option value="審核中">審核中</option>
                                <option value="已核准">已核准</option>
                                <option value="已取消">已取消</option>
                            </select>
                        </div>
                        <div className="col-md-2 mb-2">
                            <input
                                type="date"
                                className="form-control"
                                value={search.start}
                                onChange={(e) => setSearch({ ...search, start: e.target.value })}
                            />
                        </div>
                        <div className="col-md-2 mb-2">
                            <input
                                type="date"
                                className="form-control"
                                value={search.end}
                                onChange={(e) => setSearch({ ...search, end: e.target.value })}
                            />
                        </div>
                        <div className="col-md-2 mb-2">
                            <button className="btn btn-primary w-100" onClick={() => {
                                setPage(1);
                                fetchPageData();
                                fetchData(1);
                            }}>
                                搜尋
                            </button>
                        </div>
                    </div>

                    <table className="table table-striped border table-fixed w-100">
                        <ColGroup weights={colWeights} />
                        
                        <thead>
                            <tr>
                                <th>學員姓名</th>
                                <th>科目</th>
                                <th>證明文件</th>
                                <th>軟體到期日</th>
                                <th>狀態</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requestList.map((request) => (
                                <tr key={request.request_id}>
                                    <td> <a
                                                href={`/adm/admmemberedit/${request.mem_id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {request.student_name}
                                            </a>
                                        </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                                            {SUBJECT_OPTIONS.map((s) => {
                                                const selected = (updatedData.subject || []).includes(s);
                                                return (
                                                <label key={s} style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                                    <input
                                                    type="checkbox"
                                                    checked={selected}
                                                    onChange={() => toggleSubject(s)}
                                                    />
                                                    {s}
                                                </label>
                                                );
                                            })}
                                            </div>
                                        ) : (
                                            request.subject
                                        )}
                                    </td>
                                    <td>
                                        {request.proof_file ? (
                                            <a
                                                href={`/${request.proof_file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                檢視文件
                                            </a>
                                        ) : (
                                            "無"
                                        )}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="current_expiry"
                                                value={dateHelper(updatedData.current_expiry, "date")}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            dateHelper(request.current_expiry, "date")
                                        )}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <select
                                                className="form-control"
                                                name="status"
                                                value={updatedData.status}
                                                onChange={handleInputChange}
                                            >
                                                <option value="審核中">審核中</option>
                                                <option value="已核准">已核准</option>
                                                <option value="已取消">已取消</option>
                                            </select>
                                        ) : (
                                            request.status
                                        )}
                                    </td>
                                    <td>
                                        {formatDate(request.timestamp)}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="memo"
                                                value={updatedData.memo}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            request.memo
                                        )}
                                    </td>
                                    <td>
                                        {editingRequest?.request_id === request.request_id ? (
                                            <>
                                                <button className="btn btn-primary me-2" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </>
                                        ) : (
                                            <button className="btn btn-primary" onClick={() => startEditing(request)}>
                                                編輯
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center align-items-center my-3">
                        <button className="btn btn-outline-secondary me-2" disabled={page <= 1}
                            onClick={() => {
                                setPage(prev => prev - 1);
                                fetchData(page - 1);
                            }}>
                            上一頁
                        </button>
                        <span>第 {page} 頁 / 共 {Math.ceil(rowsCount / 50)} 頁</span>
                        <button className="btn btn-outline-secondary ms-2"
                            disabled={page >= Math.ceil(rowsCount / 50)}
                            onClick={() => {
                                setPage(prev => prev + 1);
                                fetchData(page + 1);
                            }}>
                            下一頁
                        </button>
                    </div>

                    </>
                )}
            </div>
        </div>
    );
}

export default ExtendRequest;